<template>
  <div class="agent-details-main">
    <Input placeholder="Agent Code" :inputValue.sync="data.agentCode" :isDisabled="viewMode" />
    <div style="display: flex">
      <Input style="margin-right: 5px" placeholder="Detention Days" :inputValue.sync="data.detentionDays" :isDisabled="viewMode" :isRequired="true" ref="Ag_DetentionDays" />
      <Input style="margin-right: 5px" placeholder="Free Demurage Days" :inputValue.sync="data.demurageDays" :isDisabled="viewMode" :isRequired="true" ref="Ag_FreeStorageDays" />
      <Input placeholder="Opr Code" :inputValue.sync="data.oprCode" :isDisabled="viewMode" />
    </div>
    <InputQuery placeholder="Depot Bill To" :items="data.billToItems" itemKey="Customer Code" descKey="Customer Name"
      :selectedObject.sync="data.selectedDepotBillTo" :isDisabled="viewMode" />
    <div class="effective-date-container">
      Effective Date From : <DateTimePicker :value.sync="data.effectiveDateStart" :isDisabled="viewMode" />
      <div></div>Until : <DateTimePicker :value.sync="data.effectiveDateEnd" :isDisabled="viewMode" />
    </div>
    <div class="compulsory-checkbox">
      <CheckBox title="Compulsory Cust Ref #" :isChecked.sync="data.compulsoryCustRef" :isDisabled="viewMode" />
    </div>
    <div>Link multiple container operations to shipping agent</div>
    <div class="add-del-opr-container">
      <Tabulator :tableData="data.contOperator" :hideColumns="hiddenColumns" :selectedRow.sync="selectedContOpr" />
      <div v-if="!viewMode" style="margin-left: 5px">
        <Input placeholder="Cont Opr" :inputValue.sync="oprCode" :errorMessage.sync="oprError" />
        <button style="margin-bottom: 5px; width: 100%" @click="addOprCode">+ Add Operator</button>
        <button style="width: 100%" @click="delOprCode">- Del Operator</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import InputQuery from '@/components/InputQuery.vue';
import CheckBox from '@/components/CheckBox.vue';
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Input, DateTimePicker, InputQuery, Tabulator, CheckBox
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    hiddenColumns: { type: Array, default: function() { return [ 'contoperatoraction' ] } },
    oprCode: { type: String, default: '' },
    oprError: { type: String, default: '' },
    selectedContOpr: { type: Array, default: function() { return [] } },
    viewMode: { type: Boolean, default: false },
  },
  methods: {
    addOprCode: function() {
      if (this.oprCode) {
        this.$bus.$emit('oprCodeAdded', { ContOperator: this.oprCode, Spp_Code: 'Test' });
        this.oprCode = '';
      } else {
        this.oprError = 'Cont Operator required';
      }
    },
    delOprCode: async function() {
      if (this.selectedContOpr.length == 0) {
        //this.$alert.showAlert('No Cont Operator Selected', 'Please select a cont operator to delete', 'error');
        this.$showAlert('error', 'No Cont Operator Selected', 'Please select a cont operator to delete');
      } else {
        var deleteContOpr = await this.$showAlert(
            'warning',
            'Cont Operator Delete', 
            `Are you sure you want to delete ${this.selectedContOpr.length} Cont Operator?`,
            [{"text" : "Delete"}, {"text" : "Cancel"}]
            );

        if (deleteContOpr === "Delete") {
          this.$bus.$emit('oprCodeDeleted', this.selectedContOpr);
        }
      }
    }
  },
  mounted() {
    this.$bus.$on('supplierAgentFocusElement', (element) => {
      this.$refs[element].setFocus();
    });
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.effective-date-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  > div {
    margin-right: 15px;
  }
}

.add-del-opr-container {
  display: flex;
}

.compulsory-checkbox {
  width: fit-content;
  margin-bottom: 10px;
}
</style>